import { FC } from 'react';
import { CommStatus } from '../../../../../../../types/communication/comm-status';
import {
  DefaultColorChip,
  ErrorColorChip,
  ProgressColorChip,
  SuccessColorChip,
  WarningColorChip
} from './comm-status-icon.styles';

export interface CommStatusIconProps {
  commStatus: CommStatus;
}

export const CommStatusIcon: FC<CommStatusIconProps> = (props) => {
  const { commStatus } = props;

  switch (commStatus) {
    case CommStatus.Confirmed:
      return <SuccessColorChip />;
    case CommStatus.Read:
    case CommStatus.LeftMessage:
      return <ProgressColorChip />;
    case CommStatus.AskedForCallback:
      return <WarningColorChip />;
    case CommStatus.Error:
    case CommStatus.RecoverableError:
    case CommStatus.WebhookProcessError:
      return <ErrorColorChip />;
    default:
      return <DefaultColorChip />;
  }
};
